import type { MappedTuple } from "@/interfaces/estimate-detail";
import { Wrench, TriangleAlert, Sparkle } from "lucide-react";
import type { Category } from "..";
import { Tab } from "./Tab";

interface TabsProps {
  className?: string;
  selectedTab?: Category;
  onSelectTab: (tab: Category) => void;
  itemCategoryTab: Record<Category, MappedTuple[]>;
}

export const Tabs = ({ className, onSelectTab, selectedTab, itemCategoryTab }: TabsProps) => {
  return (
    <div className={`flex w-full flex-row space-x-4 py-2 ${className}`}>
      {itemCategoryTab.issues?.length > 0 && (
        <Tab
          quantity={itemCategoryTab.issues.length}
          onSelect={onSelectTab}
          tab="issues"
          label={`Issue${itemCategoryTab.issues?.length > 1 ? "s" : ""}`}
          icon={<TriangleAlert className="h-5 w-5 text-yellow-500" />}
          className={`${selectedTab === "issues" ? "border border-yellow-500 bg-white" : "border-yellow-50 bg-yellow-50"}`}
        />
      )}
      {itemCategoryTab.recommended?.length > 0 && (
        <Tab
          quantity={itemCategoryTab.recommended.length}
          tab="recommended"
          label={`Recommendation${itemCategoryTab.recommended?.length > 1 ? "s" : ""}`}
          icon={<Sparkle className="h-5 w-5 text-blue-600" />}
          onSelect={onSelectTab}
          className={`${selectedTab === "recommended" ? "border border-blue-600 bg-white" : "border-blue-50 bg-blue-50"} whitespace-nowrap`}
        />
      )}
      {itemCategoryTab.removeRules.length > 0 && (
        <Tab
          quantity={itemCategoryTab.removeRules.length}
          onSelect={onSelectTab}
          tab="removeRules"
          label={`Exclusion${itemCategoryTab.removeRules?.length > 1 ? "s" : ""}`}
          icon={<Wrench className="h-5 w-5 text-purple-600" />}
          className={`${selectedTab === "removeRules" ? "border border-purple-600 bg-white" : "border-purple-50 bg-purple-50"}`}
        />
      )}
    </div>
  );
};
